import { render, staticRenderFns } from "./team_development.vue?vue&type=template&id=c62b81be&scoped=true&"
import script from "./team_development.vue?vue&type=script&lang=js&"
export * from "./team_development.vue?vue&type=script&lang=js&"
import style0 from "./team_development.vue?vue&type=style&index=0&id=c62b81be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b81be",
  null
  
)

export default component.exports